import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Internal tools + auth gate — do not push HubSpot pageviews
    if (location.pathname.startsWith('/internal')) return;

    const currentPath = location.pathname + location.search;
    var _hsq = (window._hsq = window._hsq || []);
    _hsq.push(['setPath', currentPath]);
    _hsq.push(['trackPageView']);
  }, [location]);

  return null; // This component does not render anything
};

export default PageTracker;
